import * as React from 'react';
import cn from 'classnames';
import styles from './Pagination.module.scss';
import { Pagination as AntPagination } from 'antd';
import type { PaginationProps as AntPaginationProps } from 'antd';
// import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

type DivPropsWithoutConflicts = Omit<
    React.HTMLAttributes<HTMLDivElement>,
    keyof AntPaginationProps
>;

export interface PaginationProps
    extends DivPropsWithoutConflicts,
    AntPaginationProps { }

export const Pagination = React.forwardRef<HTMLDivElement, PaginationProps>(
    ({
        className,
        pageSize,
        onShowSizeChange,
        current,
        onChange,
        total,
        ...props
    }) => {

        return (
            <div className={cn(styles.paginationContainer, className)}>
                <AntPagination
                    className={styles.pagination}
                    current={current}
                    showLessItems
                    showQuickJumper
                    itemRender={
                        (page, type, originalElement) => {
                            if (type === 'prev') {
                                // return <FaAngleLeft className={styles.prev} />;
                                return '<';
                            }
                            if (type === 'next') {
                                // return <FaAngleRight className={styles.next} />;
                                return '>' ;
                            }
                            return originalElement;
                        }
                    }
                    onChange={onChange}
                    total={total}
                    pageSize={pageSize}
                    defaultPageSize={pageSize}
                    showSizeChanger={true}
                    onShowSizeChange={onShowSizeChange}
                    {...props}
                />
            </div>
        );
    }
);